module.exports = __webpack_public_path__ + "watchDogsBackground.png";